export default (val = "", fmt = "USD", reverse = false) => {
  const num = Number(
    String(val)
      .replace(/[^0-9.,-]/g, "") // remove any non-numeric char
      .replace(/^0+/, "") // remove any leading zeros
      .replace(/[,.](?=.*?[,.])/, "") // remove any comma/period radix character
      .replace(/[,]/, "."), // replace comma decimal with period decimal
  );
  if ((!val && val !== 0) || Number.isNaN(num)) return String(val);
  if (!reverse) {
    switch (fmt.toUpperCase()) {
      case "CHF":
        return `${((num ?? 0) / 100).toFixed(2)} CHF`.replace(".", ",");
      case "GBP":
        return `£ ${((num ?? 0) / 100).toFixed(2)}`;
      case "SEK":
        return `${((num ?? 0) / 100).toFixed(2)}kr`;
      case "TRY":
        return `₺ ${((num ?? 0) / 100).toFixed(2)}`;
      case "EUR":
        return `€ ${((num ?? 0) / 100).toFixed(2)}`.replace(".", ",");
      case "DECIMAL":
        return ((num ?? 0) / 100).toFixed(2);
      case "INTEGER":
        return String(num);
      case "PERCENT_WHOLE":
        return `${num}%`;
      case "MINUTES":
        return `${num} Minutes`;
      case "CAD":
      case "USD":
        return `$ ${((num ?? 0) / 100).toFixed(2)}`;
      default:
        return `${((num ?? 0) / 100).toFixed(2)} ${fmt.toUpperCase()}`;
    }
  }
  switch (fmt.toUpperCase()) {
    case "PERCENT_WHOLE":
      return String(num);
    case "GBP":
    case "SEK":
    case "TRY":
    case "EUR":
    case "DECIMAL":
    case "CAD":
    case "USD":
    case "CHF":
    default:
      return String(parseInt(num * 100, 10));
  }
};
